import { render, staticRenderFns } from "./HostedFields.vue?vue&type=template&id=0054b8dd&scoped=true&"
import script from "./HostedFields.vue?vue&type=script&lang=js&"
export * from "./HostedFields.vue?vue&type=script&lang=js&"
import style0 from "./HostedFields.vue?vue&type=style&index=0&id=0054b8dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0054b8dd",
  null
  
)

export default component.exports